import { z } from "zod";
import { AccountUserSchema } from "./AccountUser";
import { BaseChangelogSchema } from "./Changelog";

export const AccountUserChangelogSchema = BaseChangelogSchema.extend({
  username: z.string(),
  editorAccountUser: z.any(),
  accountUser: AccountUserSchema,
});
export const PartialAccountUserChangelogSchema =
  AccountUserChangelogSchema.deepPartial();

export type PartialAccountUserChangelog = z.infer<
  typeof PartialAccountUserChangelogSchema
>;

export type AccountUserChangelog = z.infer<typeof AccountUserChangelogSchema>;
